import styled from 'styled-components';

export default styled.img`
	margin: 0 0 0 8px;
	width: 33px;
	height: 36px;
`;
